@import "covet-pics-vars.scss";

:host {
  font-family: var(--covet-font-family);
  // TODO check how it works on real sites
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // TODO check how it works on real sites END
  display: block;

  .error-message {
    text-align: center;
    border: 2px dashed;
    padding: 20px; 
  }
}
